import React from 'react';
import PropTypes from 'prop-types';
import { StyledTitleOnTruncate } from '../styles';

/**
 * @Component TitleOnTruncate
 * @param {*} children: passed back into the DOM with stylings based on what <TitleOnTruncate> is wrapping
 * @returns jsx styled with truncation based upon component logic
 **/

const TitleOnTruncate = ({ children, className, dataTestId = '', ...other }) => {
  return (
    <StyledTitleOnTruncate className={className} data-testid={dataTestId} {...other}>
      {children}
    </StyledTitleOnTruncate>
  );
};

TitleOnTruncate.propTypes = {
  /** This is the text between the \<TitleOnTruncate\> \</TitleOnTruncate\> tags. NOT passed as a typical prop */
  children: PropTypes.node.isRequired,
  /** Adds additional className prop to override styling */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
};

export { TitleOnTruncate };
